// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"3a2b5a95","189":"ba73cc2a","270":"f276a31a","351":"2b7fe676","444":"c35bb28e","540":"2fa0f652","553":"362169ac","767":"19a4874a","803":"7ffeee46","809":"db8e3d1e","917":"f5a857b4","964":"c75ca2d6","984":"3ec43844"}[chunkId] + ".chunk.js";
};